import sendReports from "./sendReports";
import gifts from "./gifts";
import Settings from "@/models/supplierPanel/Settings";

export default {
    namespaced: true,
    modules: {
        sendReports,
        gifts
    },

    state: () => ({
        settings: new Settings()
    }),

    mutations: {
        setSettings(state, payload) {
            state.settings = new Settings(payload);
        },
    },

    actions: {
        async getSettings({ commit }) {
            try {
                commit("setLoading", true, { root: true });

                const { data } = await Settings.getSettings();
                
                commit("setSettings", data.data);
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
            }
        },

        async updateSettings({ commit,state }) {
            try {
                commit("setLoading", true, { root: true });

                await Settings.updateSettings(state.settings);
                
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
            }
        },
    }
};
